export interface PutAwayStateType {
  isLoading: boolean
}

export const initialState: PutAwayStateType = {
  isLoading: false,
}

// Preserve the legacy empty reducer, which returns undefined after dispatch.
// eslint-disable-next-line @typescript-eslint/no-empty-function
export default function putAway(): void {}
